import {
  ContentLayout,
  HeaderBreadcrumbs,
  Loader,
  PageNotFound,
} from "../../../shared";
import * as React from "react";
import {
  Grid,
  Typography,
  Button,
  Stack,
  Card,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  FormHelperText,
  ToggleButtonGroup,
  ToggleButton,
  Chip,
} from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import ReactQuill from "react-quill";
import InputControl from "../../../shared/components/InputControl";
import { DropzoneComponents } from "../../BirthdayCoupons/components";
import AddIcon from "@mui/icons-material/Add";
import { useBirthdayCouponsV2Edit } from "../hooks";
import styled from "@emotion/styled";

const ToggleButtonStyled = styled(ToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: "#1560D4",
  },
});

export const EditBirthdayCouponsV2 = () => {
  const {
    state,
    globalData,
    handleInputChangeV2,
    onUpdateBirthdayCouponV2,
    handleAddConditionV2,
    handleDropzoneV2,
  } = useBirthdayCouponsV2Edit();

  const {
    isLoading,
    couponData,
    isSaveButtonBusy,
    ConditionList,
    isInProductRule,
  } = state;

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        customMaxQty: {
          message:
            "The Maximum Product Qty must be a non-negative number or empty.",
          rule: (val) => val === "" || val === null || val >= 0,
        },
      },
    }),
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      onUpdateBirthdayCouponV2();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  if (state.httpStatusCode === 404) {
    return <PageNotFound />;
  }

  const conditionType = [
    { label: "AND", value: 1 },
    { label: "OR", value: 2 },
  ];

  let options = ConditionList.map((v) => {
    return { value: v.id, label: v.name };
  });

  return (
    <>
      <ContentLayout
        title={"Update Birthday Promotion"}
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: "/" },
              { name: "Birthday Coupons", href: "/birthday-coupons-v2" },
              { name: "Edit" },
            ]}
          />
        }
        rightContent={
          <>
            <Button
              type="button"
              size="medium"
              variant="contained"
              onClick={onSubmit}
              disabled={isSaveButtonBusy}
            >
              Update
            </Button>
          </>
        }
      >
        {isLoading ? (
          <Loader />
        ) : (
          <Card sx={{ p: "32px 24px", mb: "24px" }}>
            {validator.current.purgeFields()}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={{ width: "150px" }}
                >
                  Details
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px">
                  <InputControl
                    name="name"
                    label="Name"
                    required
                    value={couponData?.name || ""}
                    onChange={(e) => handleInputChangeV2(e)}
                    error={validator.current.message(
                      "Name",
                      couponData?.name,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "Name",
                      couponData?.name,
                      "required",
                    )}
                  />
                  <InputControl
                    name="label"
                    label="Label"
                    autoComplete="off"
                    required
                    value={couponData?.label || ""}
                    onChange={(e) => handleInputChangeV2(e)}
                    error={validator.current.message(
                      "Label",
                      couponData?.label,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "Label",
                      couponData?.label,
                      "required",
                    )}
                  />
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Description
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="5px">
                  <ReactQuill
                    theme="snow"
                    placeholder="Description *"
                    required
                    value={couponData?.description || ""}
                    onChange={(e) => {
                      handleInputChangeV2({
                        target: {
                          name: "description",
                          value: e,
                        },
                      });
                    }}
                  />
                  <FormHelperText sx={{ color: "#C60808" }}>
                    {validator.current.message(
                      "Description",
                      couponData?.description
                        ?.replace(/<(.|\n)*?>/g, "")
                        .trim() || "",
                      "required",
                    )}
                  </FormHelperText>
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Images
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack direction="row" spacing={2}>
                  <Stack>
                    <DropzoneComponents
                      imgUrl={couponData?.mobile_image}
                      handleDropzone={(e) => {
                        handleDropzoneV2(e, "mobile_image");
                      }}
                      aspectRatio="1/1"
                    />
                  </Stack>
                  <Stack>
                    <DropzoneComponents
                      imgUrl={couponData?.desktop_image}
                      handleDropzone={(e) => {
                        handleDropzoneV2(e, "desktop_image");
                      }}
                      aspectRatio="2/1"
                    />
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />

            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Availability
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px">
                  <Stack direction="row" gap="20px">
                    <InputControl
                      label="Days Before"
                      name="start_before_days"
                      sx={{
                        width: "100%",
                      }}
                      type="number"
                      value={couponData?.start_before_days || ""}
                      onChange={(e) => handleInputChangeV2(e)}
                      required
                      error={validator.current.message(
                        "Days Before",
                        couponData?.start_before_days,
                        "required|num",
                      )}
                      helperText={validator.current.message(
                        "Days Before",
                        couponData?.start_before_days,
                        "required|num",
                      )}
                    />
                    <InputControl
                      label="Days After"
                      name="end_before_days"
                      sx={{
                        width: "100%",
                      }}
                      type="number"
                      value={couponData?.end_before_days || ""}
                      onChange={(e) => handleInputChangeV2(e)}
                      required
                      error={validator.current.message(
                        "Days After",
                        couponData?.end_before_days,
                        "required|num",
                      )}
                      helperText={validator.current.message(
                        "Days After",
                        couponData?.end_before_days,
                        "required|num",
                      )}
                    />
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Action Type
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack gap="20px">
                  <Grid item sm={8}>
                    <Stack width={"100%"} gap="20px">
                      <Stack direction="row" gap="20px">
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="discount_type"
                          value={couponData?.discount_type || 1}
                          sx={{
                            flexDirection: "row-reverse",
                          }}
                        >
                          {globalData?.coupons?.discount_type
                            ?.filter((data) => parseInt(data.value) !== 3)
                            ?.map((data, index) => (
                              <FormControlLabel
                                key={index}
                                value={parseInt(data.value)}
                                control={<Radio />}
                                label={data.label}
                                onChange={(e) => handleInputChangeV2(e)}
                              />
                            ))}
                        </RadioGroup>
                      </Stack>
                    </Stack>
                  </Grid>
                  <InputControl
                    name="discount_amount"
                    label={`Discount Amount (${parseInt(couponData?.discount_type) === 1 ? "$" : "%"
                      })`}
                    type="number"
                    value={couponData?.discount_amount || ""}
                    onChange={(e) => handleInputChangeV2(e)}
                    required
                    error={validator.current.message(
                      "Discount Amount",
                      couponData?.discount_amount,
                      "required|num",
                    )}
                    helperText={validator.current.message(
                      "Discount Amount",
                      couponData?.discount_amount,
                      "required|num",
                    )}
                  />
                </Stack>
              </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Rules
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px">
                  <Stack
                    direction="row"
                    gap="24px"
                    width="100%"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      color="#636363"
                      fontWeight={400}
                      fontSize="14px"
                    >
                      Condition Type
                    </Typography>

                    <ToggleButtonGroup
                      color="primary"
                      value={couponData?.condition_type || 1}
                      exclusive
                      onChange={(e) =>
                        handleInputChangeV2({
                          target: {
                            value: +e.target.value,
                            name: "condition_type",
                          },
                        })
                      }
                      aria-label="Platform"
                    >
                      {conditionType.map((item) => (
                        <ToggleButtonStyled
                          key={item.value}
                          sx={{
                            width: "102px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#636363",
                          }}
                          value={item.value}
                        >
                          {item.label}
                        </ToggleButtonStyled>
                      ))}
                    </ToggleButtonGroup>
                  </Stack>
                  {couponData?.conditions?.map((data, index) => {
                    // Filter options to exclude already selected conditions in other indices
                    const conditionsInOtherIndices = [];
                    couponData.conditions.forEach((rule, i) => {
                      if (index !== i) {
                        conditionsInOtherIndices.push(rule);
                      }
                    });
                    const filteredOptions =
                      options.length > 0
                        ? options.filter((op) => {
                          return !conditionsInOtherIndices.find(
                            (item) => item.id == op.value,
                          );
                        })
                        : [];

                    return (
                      <React.Fragment key={index}>
                        {index > 0 && (
                          <Chip
                            label={
                              conditionType.find(
                                (item) =>
                                  item.value === couponData.condition_type,
                              )?.label
                            }
                            color="primary"
                            variant="outlined"
                            size="small"
                            sx={{
                              bgcolor: "#1560D414",
                              marginTop: "3px",
                              width: "10%",
                            }}
                            disabled={false}
                          />
                        )}
                        <Stack direction="row" gap={1} justifyContent="center">
                          <InputControl
                            type="dropdown"
                            name="conditions"
                            disableClearable={true}
                            options={filteredOptions}
                            getOptionLabel={(option) => option.label}
                            onChange={(e, newValue) => {
                              handleInputChangeV2(newValue, index);
                            }}
                            value={
                              (filteredOptions?.length > 0 &&
                                data.id &&
                                filteredOptions?.find(
                                  (c) => c.value === data.id,
                                )) ||
                              null
                            }
                            sx={{
                              width: "100%",
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Rule"
                                required
                                error={validator.current.message(
                                  "Rule",
                                  data.id,
                                  "required",
                                )}
                                helperText={validator.current.message(
                                  "Rule",
                                  data.id,
                                  "required",
                                )}
                              />
                            )}
                          />

                          <Stack
                            alignItems="center"
                            height="48px"
                            justifyContent="center"
                          >
                            <div className="action-buttons">
                              <img
                                alt="delete"
                                onClick={() => {
                                  if (couponData.conditions?.length > 1) {
                                    handleAddConditionV2("delete", index);
                                  }
                                }}
                                className={` ${couponData.conditions?.length === 1 &&
                                  "disabled-img"
                                  }`}
                                src="/icons/ic_delete.svg"
                              />
                            </div>
                          </Stack>
                        </Stack>
                      </React.Fragment>
                    );
                  })}

                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{
                      width: "fit-content",
                      p: "7.75px  16px",
                    }}
                    disabled={couponData?.conditions?.some(
                      (c) => !c.id || c.id === "",
                    )}
                    onClick={() => handleAddConditionV2("add")}
                  >
                    Add Rule
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            {isInProductRule && (
              <>
                <Divider sx={{ mt: 3 }} />
                <Grid container spacing={2} marginTop={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      Maximum Product Qty
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack>
                      <InputControl
                        type="number"
                        name="applicable_max_product_qty"
                        label="Maximum Product Qty"
                        onChange={(e) => handleInputChangeV2(e)}
                        value={couponData?.applicable_max_product_qty || ""}
                        error={validator.current.message(
                          "Maximum Product Qty",
                          couponData?.applicable_max_product_qty,
                          "customMaxQty",
                        )}
                        helperText={validator.current.message(
                          "Maximum Product Qty",
                          couponData?.applicable_max_product_qty,
                          "customMaxQty",
                        )}
                      />
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "4px",
                          alignItems: "center",
                          padding: "6px 4px",
                        }}
                      >
                        <img
                          style={{
                            height: "18px",
                          }}
                          alt="details"
                          src="/icons/ic_info.svg"
                        />
                        <Typography
                          variant="caption"
                          lineHeight="15px"
                          color="#666666"
                        >
                          1 or empty means 1, while 0 means unlimited. Only
                          applicable for coupons with products rules.
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </>
            )}
          </Card>
        )}
      </ContentLayout>
    </>
  );
};
